/**
 * Formata uma data em um formato amigável e responsivo
 * @param dateString - String ISO ou objeto Date da notificação
 * @returns Texto formatado baseado na diferença de tempo
 */
export function formatRelativeDate(dateString: string | Date): string {
  const date =
    typeof dateString === 'string' ? new Date(dateString) : dateString;
  const now = new Date();

  // Diferença em milissegundos
  const diffMs = now.getTime() - date.getTime();

  // Proteção contra datas futuras ou inválidas
  if (Number.isNaN(diffMs) || diffMs < 0) {
    return 'agora';
  }

  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  // Menos de 20 minutos
  if (diffMinutes < 20) {
    return 'agora';
  }

  // Menos de 1 hora
  if (diffMinutes < 60) {
    return `${diffMinutes} min`;
  }

  // Mesmo dia (menos de 24h)
  if (diffDays < 1) {
    return `${diffHours}h atrás`;
  }

  // Ontem
  if (diffDays === 1) {
    return 'ontem';
  }

  // 2-6 dias atrás
  if (diffDays < 7) {
    return `${diffDays} dias atrás`;
  }

  // 1-4 semanas
  if (diffDays < 30) {
    const weeks = Math.floor(diffDays / 7);
    return weeks === 1 ? '1 semana atrás' : `${weeks} semanas atrás`;
  }

  // Caso contrário, mostrar o dia e o mês
  const months = [
    'janeiro',
    'fevereiro',
    'março',
    'abril',
    'maio',
    'junho',
    'julho',
    'agosto',
    'setembro',
    'outubro',
    'novembro',
    'dezembro',
  ];

  return `${date.getDate()} de ${months[date.getMonth()]}`;
}
